package waldo.sankan.lineamunicipalkmp.web.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun FiscalizacionDialog(
    titulo: String,
    detenidosInicial: Int,
    controlesInicial: Int,
    fiscalizacionesInicial: Int,
    onDismiss: () -> Unit,
    onConfirm: (detenidos: Int, controles: Int, fiscalizaciones: Int) -> Unit
) {
    var detenidos by remember { mutableStateOf(detenidosInicial) }
    var controles by remember { mutableStateOf(controlesInicial) }
    var fiscalizaciones by remember { mutableStateOf(fiscalizacionesInicial) }

    // Capa de fondo (Modal Imperial)
    Div({
        style {
            position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
            backgroundColor(rgba(0, 0, 0, 0.6)); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center); property("z-index", "2000")
        }
    }) {
        // Caja de contenido (Diseño Card Blanca de Élite)
        Div({
            style {
                width(500.px); backgroundColor(Color.white); borderRadius(16.px)
                padding(32.px); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                property("box-shadow", "0px 10px 40px rgba(0,0,0,0.4)")
            }
        }) {
            // --- ENCABEZADO ESTILO DOSSIER ---
            Div({
                style {
                    color(Color("#388E3C")); fontWeight("900"); fontSize(14.px)
                    letterSpacing(1.5.px); marginBottom(8.px)
                }
            }) { Text("GESTIÓN DE PROCEDIMIENTOS") }

            H2({ style { marginTop(0.px); marginBottom(24.px); color(Color.black); fontWeight("bold") } }) {
                Text(titulo)
            }

            // --- SECCIÓN DE CONTADORES ---
            Div({
                style {
                    display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(24.px)
                    padding(16.px); backgroundColor(Color("#f8f9fa")); borderRadius(12.px)
                    border(1.px, LineStyle.Solid, Color("#dee2e6")); marginBottom(24.px)
                }
            }) {
                // Fila 1: Fiscalizaciones
                CounterRow(
                    label = "FISCALIZACIONES REALIZADAS:",
                    valor = fiscalizaciones,
                    onIncrement = { fiscalizaciones++ },
                    onDecrement = { if (fiscalizaciones > 0) fiscalizaciones-- }
                )

                // Fila 2: Controles de Identidad
                CounterRow(
                    label = "CONTROLES DE IDENTIDAD:",
                    valor = controles,
                    onIncrement = { controles++ },
                    onDecrement = { if (controles > 0) controles-- }
                )

                // Fila 3: Detenidos
                CounterRow(
                    label = "PERSONAS DETENIDAS:",
                    valor = detenidos,
                    onIncrement = { detenidos++ },
                    onDecrement = { if (detenidos > 0) detenidos-- },
                    accentColor = "#D32F2F" // Rojo para detenidos
                )
            }

            // --- PIE DE DIÁLOGO (ACCIONES) ---
            Div({
                style {
                    display(DisplayStyle.Flex); justifyContent(JustifyContent.End)
                    gap(16.px); marginTop(16.px)
                }
            }) {
                Button(attrs = {
                    onClick { onDismiss() }
                    style {
                        color(Color.gray); fontWeight("bold"); fontSize(16.px); cursor("pointer")
                        padding(12.px, 24.px); backgroundColor(Color.transparent); border(0.px)
                    }
                }) { Text("CANCELAR") }

                Button(attrs = {
                    onClick { onConfirm(detenidos, controles, fiscalizaciones) }
                    style {
                        padding(12.px, 32.px); fontSize(16.px); fontWeight("bold")
                        backgroundColor(Color("#388E3C")); color(Color.white)
                        border(0.px); borderRadius(8.px); cursor("pointer")
                        property("box-shadow", "0px 4px 12px rgba(56, 142, 60, 0.3)")
                    }
                }) {
                    Text("GUARDAR REGISTRO")
                }
            }
        }
    }
}

@Composable
private fun CounterRow(
    label: String,
    valor: Int,
    onIncrement: () -> Unit,
    onDecrement: () -> Unit,
    accentColor: String = "#388E3C"
) {
    Div({
        style {
            display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween)
            alignItems(AlignItems.Center)
        }
    }) {
        B({ style { fontSize(14.px); color(Color.gray) } }) { Text(label) }

        Div({
            style {
                display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(16.px)
            }
        }) {
            // Botón Menos
            Button(attrs = {
                onClick { onDecrement() }
                style {
                    width(36.px); height(36.px); borderRadius(50.percent); cursor("pointer")
                    border(1.px, LineStyle.Solid, Color(accentColor)); backgroundColor(Color.white)
                    color(Color(accentColor)); fontWeight("bold"); fontSize(20.px)
                    display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                }
            }) { Text("-") }

            // Valor
            Span({
                style {
                    fontSize(22.px); fontWeight("bold"); minWidth(30.px); textAlign("center")
                    color(Color.black)
                }
            }) { Text(valor.toString()) }

            // Botón Más
            Button(attrs = {
                onClick { onIncrement() }
                style {
                    width(36.px); height(36.px); borderRadius(50.percent); cursor("pointer")
                    border(0.px); backgroundColor(Color(accentColor)); color(Color.white)
                    fontWeight("bold"); fontSize(20.px)
                    display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                }
            }) { Text("+") }
        }
    }
}
